import { useCallback } from 'react';
import { useRouter } from 'next/router';

import { logError } from ':support/utils/error-vitals/logging';
import { clearRedirectUri, getRedirectUri } from ':support/utils/session-utils/redirectUriStorage';

/**
 * Hook to handle post-authentication redirects
 * @returns Object containing the handleRedirect function
 */
export function useRedirectHandler() {
  const router = useRouter();

  const handleRedirect = useCallback(async (): Promise<void> => {
    const redirectUri = getRedirectUri();
    if (!redirectUri) return;

    try {
      await router.replace(redirectUri);
      clearRedirectUri();
    } catch (error) {
      logError(
        error instanceof Error ? error : new Error('Redirect failed'),
        {
          context: 'useRedirectHandler',
          severity: 'error',
        },
        {
          redirectUri,
          originalError: error instanceof Error ? error.message : String(error),
        },
      );
    }
  }, [router]);

  return { handleRedirect };
}
